<template>
    <v-card elevation="2" shaped class="ma-1">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Paramètres de la Geoloc</v-toolbar-title>
      </v-toolbar>

      <div>

        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> requete </v-tab>
          <v-tab> Paramètres</v-tab>
          <v-tab> Image</v-tab>
          <v-tab>tableau de proximité</v-tab>
          
          <v-tabs-items v-model="tab" class="pl-4">

            <v-tab-item>


              <v-tabs align="start" background-color="blue lighten-5 ma-3" v-model="tab2">
          <v-tab> filtre </v-tab>
          <v-tab> champs </v-tab>
          
          <v-tabs-items v-model="tab2" class="pl-4">
              <v-tab-item>
                  <Filtre
                    :filtre="displays.params.filtre"
                    :table="module.table"
                  />
              </v-tab-item>

              <v-tab-item>
                <Fields
                  :table="module.table"
                  :champs="displays.params.champs"
                  :filter="displays.params.filtre"
                  :modalKey="modalKey"
                  :page="page"
                  />
              </v-tab-item>
          </v-tabs-items>
          </v-tabs>




            </v-tab-item>

            <v-tab-item>

              <Select
              :item="{name: 'Champ pour latitude',value: 'lat',liste: listFields,
              defaultprops:{ show: true}}"
              :change="(item,value,select) => { displays.params.mapfields.lat = value[select];}"
              :valField="displays.params.mapfields.lat"
                /> 
              <Select
              :item="{name: 'Champ pour longitude',value: 'lat',liste: listFields,
              defaultprops:{ show: true}}"
              :change="(item,value,select) => { displays.params.mapfields.lon = value[select];}"
              :valField="displays.params.mapfields.lon"
                />
              <Select
              :item="{name: 'Champ pour date de dernière geoloc',value: 'lat',liste: listFields,
              defaultprops:{ show: true}}"
              :change="(item,value,select) => { displays.params.mapfields.lastgeoloc = value[select];}"
              :valField="displays.params.mapfields.lastgeoloc"
                />
                Construction de l'adresse pour demande API
            <ArrayTable 
                :item="{otherparams:{
                    arrayTable:[
                        {type:'',key:'name',name:'Paramètre'},{type:'switch',key:'oblig',name:'champ obligatoire'}]}
                ,defaultprops:{show:true,tableDraggable:true,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'Ajouter un paramètre'}}"
                :valField="displays.params.mapadresse"
                :change="(item,value) => {displays.params.mapadresse = value; $emit('recepVal',displays);}"
                />


            </v-tab-item>

            <v-tab-item>
              <SwitchC
              :item="{ name: 'Activer affichage image', value: 'show', 
              defaultprops:{ show: true}}"
              :valField="displays.params.image.set"
              :change="(item,value) => {displays.params.image.set = value;}"
              />
              <TextField 
              :item="{name:'Zoom (de 1 à 20)',value:'zoom',defaultprops:{show:true}}" 
              :keyup="(item,value) => { displays.params.image.zoom = value;}"
              :valField="displays.params.image.zoom" />
              <TextField 
              :item="{name:'Taille',value:'zoom',defaultprops:{show:true}} " 
              :keyup="(item,value) => { displays.params.image.size = value; }"
              :valField="displays.params.image.size" />
              <TextField 
              :item="{name:'Marker',value:'zoom',defaultprops:{show:true}} " 
              :keyup="(item,value) => { displays.params.image.markers = value; }"
              :valField="displays.params.image.markers" />
            </v-tab-item>



            <!-- tableau pour proximité -->
            <v-tab-item>

              <SwitchC
              :item="{ name: 'Affichage du tableau', value: 'show', 
              defaultprops:{ show: true}}"
              :valField="displays.params.proxyquery.set"
              :change="(item,value) => {displays.params.proxyquery.set = value;}"
              />

              <Select
              v-if="displays.params.proxyquery.set"
              :item="{name: 'Table sujet à la liste de proximité',value: 'lat',liste: listTables,
              defaultprops:{ show: true, clearable:true}}"
              :change="changeProxiTable"
              :valField="displays.params.proxyquery.table"
                /> 


              <v-tabs align="start" background-color="blue lighten-5 ma-3" v-model="tab3" v-if="displays.params.proxyquery.table && displays.params.proxyquery.set" :key="reloadTab">
              <v-tab> correspondance </v-tab>
              <v-tab> filtre </v-tab>
              <v-tab> champs </v-tab>
              <v-tab> Actions </v-tab>
              
                <v-tabs-items v-model="tab3" class="pl-4">

                    <v-tab-item>
                      <Select
                      :item="{name: 'Champ pour latitude',value: 'fieldlat',liste: listFieldsProxy,
                      defaultprops:{ show: true}}"
                      :change="(item,value,select) => { displays.params.proxyquery.fieldlat = value[select];}"
                      :valField="displays.params.proxyquery.fieldlat"
                        /> 
                      <Select
                      :item="{name: 'Champ pour longitude',value: 'fieldlon',liste: listFieldsProxy,
                      defaultprops:{ show: true}}"
                      :change="(item,value,select) => { displays.params.proxyquery.fieldlon = value[select];}"
                      :valField="displays.params.proxyquery.fieldlon"
                        />


                      <TextField 
                      :item="{name:'Limite d\'affichage des lignes',value:'lines',defaultprops:{show:true,format:'number'}}" 
                      :keyup="(item,value) => { displays.params.proxyquery.lines = value;}"
                      :valField="displays.params.proxyquery.lines" />
                      <TextField 
                      :item="{name:'Limite d\'affichage en distance',value:'distance',defaultprops:{show:true,format:'number'}}" 
                      :keyup="(item,value) => { displays.params.proxyquery.distance = value;}"
                      :valField="displays.params.proxyquery.distance" />
                    </v-tab-item>

                    <v-tab-item>
                      Vous pouvez utiliser la variable [[line||...]] issue des données de la requete principale
                        <Filtre
                          :filtre="displays.params.proxyquery.filtre"
                          :table="displays.params.proxyquery.table"
                        />
                    </v-tab-item>

                    <v-tab-item>
                      <Fields
                        :table="displays.params.proxyquery.table"
                        :champs="displays.params.proxyquery.champs"
                        :filter="displays.params.proxyquery.filtre"
                        :modalKey="modalKey"
                        :page="page"
                        />
                    </v-tab-item>
                    <v-tab-item>
                    <listActions :page="page" :module="module" :key="reloadAction" />  
                    </v-tab-item>
                </v-tabs-items>
              </v-tabs>              

            </v-tab-item>

          </v-tabs-items>
        </v-tabs>
    </div>
    </v-card>
  </template>



  <script>
import { admin } from '../mixins'; 
  export default {
    name: "GeolocModule",
    mixins : [admin],
  
    data: function () {
      return {

        displays: this.module.displays,
        tab : '',
        tab2 : '',
        tab3 : '',
        listFields : [],
        listTables : [],
        listFieldsProxy : [],
        reloadTab : 0,
        reloadAction: 0,

      };
    },
  
    watch: {


  },
  
    methods: {

    getFields() {

      this.API({ type: 'post', url: 'engine/module/getfieldswithjunctions', params: { table: this.module.table, filter: this.displays.params.filtre } }).then((resp) => {
        resp.data.fields.forEach((field) => {
          this.listFields.push({ 'text': field.table + '.' + field.field, value: field.cle, id:field.id, table:field.table })
        })
      })

    },

    getFieldsProxy() {
      this.listFieldsProxy = []
      this.API({ type: 'post', url: 'engine/module/getfieldswithjunctions', params: { table: this.displays.params.proxyquery.table, filter: this.displays.params.filtre } }).then((resp) => {
        resp.data.fields.forEach((field) => {
          this.listFieldsProxy.push({ 'text': field.table + '.' + field.field, value: field.cle, id:field.id, table:field.table })
        })
      })

    },

    changeProxiTable(item,value) {

      this.displays.params.proxyquery.table = value.value;
      if(value) {
        this.reloadTab++;
        this.displays.params.proxyquery.champs = []
        this.displays.params.proxyquery.filtre = []
        this.displays.params.proxyquery.fieldlon = ''
        this.displays.params.proxyquery.fieldlat = ''
        this.getFieldsProxy()
      }
    }
  
    },
  
    mounted() {
        this.getFields();

        this.API({type:'get', url:'engine/getlisttable'}).then((resp) => {
            resp.data.forEach((table) => {
                this.listTables.push({text:table,value:table})
            })
            
        })

        if(this.displays.params.proxyquery.table!='') {
          this.getFieldsProxy()
        }


    },


  };
  </script>